import React, { Fragment } from "react";
//import { Link, withRouter } from 'react-router-dom'
import { deBaseAFechaLocal } from "../../../../utils/Tools.js";
//import { productosAPI } from '../../../../utils/funcionesAPI'
//import {manejadorDeRespuesta} from '../../../../utils/Tools'
//import {RUTA_ITINERARIO} from '../../../../utils/rutasFijas'
//import { toast } from 'react-toastify'

const Detalle = (props) => {
  const { reserva } = props;
  const producto = props.reserva.producto;
  //const codigoItinerario = producto.destino.idDestino + producto.dias + producto.noches + producto.transporte.descripcion +  producto.transporte.codigoCategoria;

  function mostrarPasajeros(pasajeros) {
    let datosPasajeros = "";

    pasajeros.forEach(function (pasajero) {
      datosPasajeros +=
        pasajero.nombre +
        " " +
        pasajero.apellido +
        " " +
        pasajero.tipoDocumento +
        " " +
        pasajero.documento +
        " (" +
        pasajero.tipoPasajero +
        "). ";
    });

    return datosPasajeros;
  }

  function mostrarPasajerosEnTabla(pasajeros) {
    pasajeros.forEach(function (pasajero) {
      return (
        <tr>
          <td>{pasajero.nombre}</td>
          <td>{pasajero.apellido}</td>
          <td>{pasajero.tipoDocumento}</td>
          <td>{pasajero.documento}</td>
          <td>({pasajero.tipoPasajero})</td>
        </tr>
      );
    });
  }

  function mostrarEstadosDeReserva(reserva) {
    if (reserva.estado === 9)
      return <strong className="textoCancelada">CANCELADA</strong>;

    if (parseFloat(reserva.totalCobrado) >= 0.01)
      return <strong className="textoConfirmada">CONFIRMADA</strong>;

    return <strong>{deBaseAFechaLocal(reserva.fechaVencimiento)}</strong>;
  }

  function mostrarFechasCDRoSalida(reserva) {
    if (reserva.canal === "CDR") {
      return (
        <Fragment>
          <span>Fecha In: </span>
          <strong>{deBaseAFechaLocal(reserva.fechaIn)}</strong>.
          <span>Fecha Out: </span>
          <strong>{deBaseAFechaLocal(reserva.fechaOut)}</strong>
        </Fragment>
      );
    }

    return (
      <Fragment>
        <span>Fecha:</span>
        <strong>{deBaseAFechaLocal(reserva.charter.fechaSalida)}</strong>
      </Fragment>
    );
  }

  function mostrarTitulo(reserva) {
    let title = `${producto.detalleWeb} ${producto.dias} Dias - ${producto.noches} Noches`;
    if (reserva.canal === "CDR") {
      title = reserva.producto.detalleWeb;
    }
    return title;
  }

  return (
    <div className="info misReservasDetalle col-xl-7 col-lg-7 col-md-6 col-sm-12 col-12">
      <h2 id="misReservasNombreProducto">{mostrarTitulo(reserva)}</h2>
      <div className="tab-content" id="pills-destino-content">
        {/*Descripcion */}
        <div
          className="tab-pane d-inline-block fade show active col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
          id="pills-descripcion"
          role="tabpanel"
          aria-labelledby="pills-descripcion-tab"
        >
          <p>
            <span>N&uacute;mero de Reserva: </span>
            <strong>{reserva.numeroReserva}</strong>.<span>Regimen: </span>
            <strong>{producto.regimen.descripcion}</strong>.
            {reserva.canal !== "CDR" && (
              <Fragment>
                <span>Transporte:</span>{" "}
                <strong>
                  {producto.transporte.descripcion +
                    " - " +
                    producto.transporte.categoria}
                </strong>
                .
              </Fragment>
            )}
          </p>
          <p>
            {mostrarFechasCDRoSalida(reserva)}. <span>Fecha Vencimiento: </span>
            {mostrarEstadosDeReserva(reserva)}
          </p>
          <p>
            <span>Pasajeros: </span>
            <strong>{reserva.cantidadPasajeros}.</strong>
            <div
              className="dropdown cuadroPuntosEmbarques"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              <i
                className="material-icons alineacionIconoContenido dropdown-toggle"
                title="Ver Pasajeros"
              ></i>{" "}
              <span className="btnVerPasajeros">VER PASAJEROS</span>
              <div
                className="dropdown-menu cuadroPasajeros text-left"
                aria-labelledby="dropdownMenuButton"
                style={{'left': '-170px'}}
              >
                <table className="tablaPasajerosEnMisReservas">
                  <thead>
                    <tr>
                      <th>Nombre</th>
                      <th>Apellido</th>       
                      <th>N. Doc</th>
                      <th>F.Nac</th>
                      <th>T.E</th>
                    </tr>
                  </thead>
                  <tbody>
                  {reserva.pasajeros.length === 0 && (
                        <tr>
                          <td colSpan="5">No hay pasajeros informados</td>
                        </tr>
                  )}
                    {reserva.pasajeros.map((pasajero) => {
                      return (
                        <tr>
                          <td>{pasajero.nombre}</td>
                          <td>{pasajero.apellido}</td>
                          <td>{pasajero.tipoDocumento}: {pasajero.documento}</td>
                          <td>{pasajero.fechaNacimiento} ({pasajero.tipoPasajero})</td>
                          <td>{pasajero.telefono}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </p>
          {reserva.canal !== "CDR" && (
            <p>
              <span>Punto de Embarque: </span>{" "}
              <strong>
                {reserva.puntoDeEmbarque.denominacion} -{" "}
                {reserva.puntoDeEmbarque.direccion}
              </strong>
              . <span>Hora: </span>
              <strong> {reserva.puntoDeEmbarque.hora}</strong>
            </p>
          )}
          {reserva.canal === "CDR" && (
            <p>
              <span>Tipo de Habitación: </span>{" "}
              <strong>{reserva.tipoHabitacion}</strong>
            </p>
          )}

          {/*FC: descomentar cuando se vuelva a usar pesos
          producto.moneda.codigoMoneda !== "PES" && (
            <p>
              <strong className="textoCancelada">
                Este paquete se comercializa en {producto.moneda.codigoMoneda}{" "}
                con un T. Cambio 1 {producto.moneda.codigoMoneda} = ${" "}
                {producto.moneda.cotizacion.substr(0, 5)}
              </strong>
            </p>
          )*/}
          <p>
            <span>Ejecutivo de Cuenta: </span>{" "}
            <strong>{reserva.vendedor.denominacion}</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Detalle;



// WEBPACK FOOTER //
// ./src/components/MisReservas/ListadoReservas/ReservaFila/Detalle.js